import React, { useContext, useEffect, useRef, useState } from 'react';
import { Redirect, useLocation } from 'react-router';
import { apiClient, closeSocket, createSocket, TokenManager } from '../../utils';
import { UserContext } from '../contexts';
import { Grid } from '../../models';

export function SessionPage() {
  const location = useLocation();
  const from = (location.state as any)?.from;
  const fromPath = from?.pathname || '/';
  const fromSearch = from?.search || '';
  const urlParams = new URLSearchParams(location.search);
  const loginCallback = urlParams.get('logincallback');
  const accessToken = urlParams.get('access_token');
  const refreshToken = urlParams.get('refresh_token');

  const [ready, setReady] = useState(false);

  const [gridChecked, setGridChecked] = useState(false);
  const [gridRedirectUrl, setGridRedirectUrl] = useState<string>();

  const { user, setUser } = useContext(UserContext);
  const hasCheckedAuth = useRef(false);

  let redirectUrl = '/login';
  if (loginCallback) {
    redirectUrl = '/unauthorized';
  }

  useEffect(() => {
    // Prevent running the authentication check multiple times
    if (hasCheckedAuth.current) {
      return;
    }

    const checkAuthentication = async () => {
      hasCheckedAuth.current = true;

      // If we have tokens from the URL (from login callback), store them
      if (accessToken && refreshToken) {
        TokenManager.setTokens(accessToken, refreshToken);

        // Clean up URL by removing tokens
        const newUrl = `${window.location.pathname}?logincallback=1`;
        window.history.replaceState({}, document.title, newUrl);
        // Continue to fetch user from API below
      }

      // Always fetch user from database if we have a token
      if (!TokenManager.getAccessToken()) {
        setReady(true);
        return;
      }

      try {
        const response = await apiClient.get('users/me');
        if (response.data.email) {
          setUser(response.data);
          createSocket();
        } else {
          setUser(undefined);
          setReady(true);
          closeSocket();
        }
      } catch (error) {
        TokenManager.clearTokens();
        setUser(undefined);
        setReady(true);
        closeSocket();
      }
    };

    checkAuthentication();
  }, [user, setUser, accessToken, refreshToken]);

  useEffect(() => {
    if (!user) {
      return;
    }

    apiClient
      .get('grids')
      .then((response: any) => {
        const grids = response.data as Grid[];
        if (grids?.length === 1) {
          setGridRedirectUrl('grids/' + grids[0].id);
        }
        setGridChecked(true);
      })
      .catch(() => {
        setGridChecked(true);
      });
  }, [user]);

  return (
    <>
      {!user && ready && <Redirect to={redirectUrl} />}
      {user && gridChecked && <Redirect to={gridRedirectUrl || fromPath + fromSearch} />}
    </>
  );
}
